module.exports = __webpack_public_path__ + "img/HDBANK.2d400016.svg";